import React, { useState } from 'react';

export enum Color {
    GRAY = 'gray',
    MINT = 'mint',
    YELLOW = 'yellow',
    RED = 'red',
    PINK = 'pink',
    MAJENTA = 'majenta',
}

export const useSelectColor = (
    onFilteredData: (name: 'colors', value: string[]) => void,
    filteredData: { colors: string[] }
) => {
    const [isOpen, setIsOpen] = useState(false);
    const activeColor = {
        [Color.GRAY]: filteredData.colors.includes(Color.GRAY),
        [Color.MINT]: filteredData.colors.includes(Color.MINT),
        [Color.YELLOW]: filteredData.colors.includes(Color.YELLOW),
        [Color.RED]: filteredData.colors.includes(Color.RED),
        [Color.PINK]: filteredData.colors.includes(Color.PINK),
        [Color.MAJENTA]: filteredData.colors.includes(Color.MAJENTA),
    };
    const changeActiveColor = (color: Color) => {
        onFilteredData(
            'colors',
            activeColor[color]
                ? filteredData.colors.filter((item) => item !== color)
                : [...filteredData.colors, color]
        );
    };
    const changeOpen = () => setIsOpen((previous) => !previous);
    const resetColors = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        onFilteredData('colors', []);
    };
    const selectedColor = filteredData.colors;
    const isSelected = !!filteredData.colors.length;
    return {
        isOpen,
        changeOpen,
        changeActiveColor,
        activeColor,
        selectedColor,
        setIsOpen,
        isSelected,
        resetColors,
    };
};
